import { useEffect } from "react";
import { messageAndErrorStore, userStore } from "../store/Store";
import { useNavigate } from "react-router-dom";
import {
  GenerateCustomerDownload,
  GenerateReceivedDownload,
  GenerateVendorInvoiceDownload,
} from "../funcs/invoicing/GenerateDownload";

export default function useDownloadProjectInvoice(
  isCustomer,
  fscMethodTrigger,
  currentProject,
  setDownloadPending,
  setFscMethodTrigger,
  fscMethod,
  dlInvoice,
  customerRateSheet,
  projectSandRates,
  isReceived,
  projectId,
) {
  const setAuthStatus = userStore((data) => data.setAuthStatus);
  const JwtToken = userStore((data) => data.JwtToken);
  const toggleNewMessage = messageAndErrorStore(
    (data) => data.toggleNewMessage,
  );
  const navigate = useNavigate();
  useEffect(() => {
    if (!fscMethodTrigger && dlInvoice) {
      performDownload(dlInvoice);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fscMethodTrigger, dlInvoice]);

  const performDownload = (dlInvoice) => {
    setDownloadPending(true);
    const controller = new AbortController();
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + JwtToken);
    const requestOptions = {
      method: "GET",
      headers,
      signal: controller.signal,
    };
    if (isCustomer) {
      let invoiceLoads;
      let invoice;
      let totals;
      let adjustments;
      fetch(
        `${process.env.REACT_APP_BACKEND}/pc/customer/invoice/${dlInvoice.id}`,
        requestOptions,
      )
        .then((res) => {
          if (res.status === 401) {
            navigate("/login");
            setAuthStatus(false);
            setDownloadPending(false);
          } else {
            setAuthStatus(true);
            setDownloadPending(false);
            return res.json();
          }
        })
        .then((data) => {
          if (data.error) {
            toggleNewMessage(data.message);
            setDownloadPending(false);
            return;
          } else {
            invoiceLoads = data.loads;
            invoice = data.invoice;
            totals = data.invoice_totals;
          }
        })
        .then(
          fetch(
            `${process.env.REACT_APP_BACKEND}/lc/invoice-adjustment/${dlInvoice.id}?is_vendor=false&is_received=false&project_id=${currentProject.project.id}`,
            requestOptions,
          )
            .then((res) => {
              if (!res.ok) {
                if (res.status === 401) {
                  setAuthStatus(false);
                  navigate("/login");
                  setDownloadPending(false);
                  return Promise.resolve();
                } else {
                  toggleNewMessage(
                    `Could not get invoice Status ${res.statusText}`,
                  );
                  setDownloadPending(false);
                  return Promise.resolve();
                }
              } else {
                return res.json();
              }
            })
            .then((data) => {
              if (!data) {
                return;
              } else {
                adjustments = data;
              }
            }),
        )
        .then(() => {
          GenerateCustomerDownload(
            invoice,
            invoiceLoads,
            currentProject.project.job_name,
            null,
            null,
            adjustments,
            projectSandRates,
            totals,
            fscMethod,
          );
          setDownloadPending(false);
        })
        .catch((err) => {
          toggleNewMessage(err);
          setDownloadPending(false);
          return;
        })
        .finally(() => setDownloadPending(false));
      return () => controller.abort();
    } else if (isReceived) {
      fetch(
        `${process.env.REACT_APP_BACKEND}/lc/account-invoice/${dlInvoice.id}?project_id=${projectId}`,
        requestOptions,
      )
        .then((res) => {
          if (!res.ok) {
            toggleNewMessage(`${res.statusText} Status: ${res.status}`);
            return Promise.resolve();
          } else {
            return res.json();
          }
        })
        .then((data) => {
          if (!data) {
            return;
          } else {
            GenerateReceivedDownload(
              dlInvoice,
              data.invoice_loads,
              data.adjustments,
              data.uninvoiced_loads,
              data.uninvoiced_total,
              fscMethod,
            );
            toggleNewMessage(null, "Downloading");
          }
        })
        .catch((err) => {
          console.log(err);
          toggleNewMessage("Something went wrong");
        })
        .finally(() => setDownloadPending(false))
      return () => controller.abort();
    } else {
      setDownloadPending(true);
      const controller = new AbortController();
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + JwtToken);
      const requestOptions = {
        method: "GET",
        headers,
        signal: controller.signal,
      };
      let invoice;
      let invoiceLoads;
      let uninvoicedLoads;
      let uninvoicedTotal;
      let adjustments;

      fetch(
        `${process.env.REACT_APP_BACKEND}/pc/vendor/invoice/${dlInvoice.id}`,
        requestOptions,
      )
        .then((res) => {
          if (!res.ok) {
            if (res.status === 401) {
              setAuthStatus(false);
              navigate("/login");
              setDownloadPending(false);
              return Promise.resolve();
            } else {
              toggleNewMessage(
                `Could not get invoice Status ${res.statusText}`,
              );
              setDownloadPending(false);
              return Promise.resolve();
            }
          } else {
            return res.json();
          }
        })
        .then((data) => {
          if (!data) {
            return;
          } else {
            invoice = data.invoice;
            invoiceLoads = data.loads;
            uninvoicedLoads = data.uninvoiced_loads;
            uninvoicedTotal = data.uninvoiced_total;
          }
        })
        .then(
          fetch(
            `${process.env.REACT_APP_BACKEND}/lc/invoice-adjustment/${dlInvoice.id}?is_vendor=true&is_received=false&project_id=${currentProject.project.id}`,
            requestOptions,
          )
            .then((res) => {
              if (!res.ok) {
                if (res.status === 401) {
                  setAuthStatus(false);
                  navigate("/login");
                  setDownloadPending(false);
                  return Promise.resolve();
                } else {
                  toggleNewMessage(
                    `Could not get invoice Status ${res.statusText}`,
                  );
                  setDownloadPending(false);
                  return Promise.resolve();
                }
              } else {
                return res.json();
              }
            })
            .then((data) => {
              if (!data) {
                return;
              } else {
                adjustments = data;
              }
            }),
        )
        .then(() => {
          GenerateVendorInvoiceDownload(
            invoice,
            invoiceLoads,
            uninvoicedLoads,
            uninvoicedTotal,
            currentProject.project.job_name,
            null,
            null,
            adjustments,
            fscMethod,
          );
          setDownloadPending(false);
        })
        .catch((err) => {
          console.log(err);
          toggleNewMessage("Something went wrong");
          setDownloadPending(false);
          return;
        })
        .finally(() => setDownloadPending(false));
      return () => controller.abort();
    }
  };
}
